module.exports = __webpack_public_path__ + "img/add-issue.9a6d8f89.svg";